import classNames from '@sindresorhus/class-names';
import Image from 'next/image';

import chevron from '@shared/Articles/assets/chevron.svg';

import styles from './SlideControlButton.module.scss';

type Props = {
  direction: 'next' | 'prev';
  testId?: string;
  onClick: () => void;
  className?: string;
  /**
   * this places element absolutely in container,
   * centered vertically and aligned to left/right depending on direction
   */
  standardPosition?: boolean;
};

export default function SlideControlButton({
  className,
  testId,
  direction,
  standardPosition,
  onClick,
}: Props) {
  return (
    <button
      className={classNames(
        styles.button,
        className,
        styles[direction],
        standardPosition && styles.standardPosition,
      )}
      onClick={onClick}
      {...(testId && {'data-testid': testId})}
    >
      <Image src={chevron} width={24} height={24} alt="" />
    </button>
  );
}
